/**
 * OverallDashboardPage: the group-wide dashboard, hosted under the first-class
 * "Overall" scope and the default landing after login.
 *
 * This mounts EntitiesAggregateTabs (the genuinely group-wide Overview /
 * Summary / Detailed view that previously lived under Entities > All Entities).
 * The component is moved here, not copied: EntitiesAggregateTabs remains the
 * single source and is no longer rendered by DashboardPage.
 *
 * The active tab is URL-addressable (?tab=) so deep links keep working.
 *
 * The route owns the scope: arriving on /overall (root redirect, deep link,
 * or a reload with a different scope persisted) aligns selectedScope to
 * 'overall' so the sidebar picker/nav are consistent. This alignment runs
 * once on mount only, not on every selectedScope change: the picker/logo set
 * the new scope and then navigate away from here in the same tick, and while
 * this page is still mounted for that one tick, a mount+update effect would
 * "correct" the just-picked scope straight back to overall before the target
 * route ever saw it (the picker looks like a no-op, or the sidebar nav
 * desyncs from the page it lands on).
 */

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../components/DashboardLayout';
import { EntitiesAggregateTabs } from '../components/dashboard/entities/EntitiesAggregateTabs';
import { useEntityStore } from '../store';

export function OverallDashboardPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');

  useEffect(() => {
    var state = useEntityStore.getState();
    if (state.selectedScope !== 'overall') state.setSelectedScope('overall');
    // Mount-only by design -- see the file-level comment above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (newTab) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', newTab);
    setSearchParams(next, { replace: true });
  };

  return (
    <DashboardLayout>
      <EntitiesAggregateTabs
        tab={urlTab || 'overview'}
        onTabChange={handleTabChange}
      />
    </DashboardLayout>
  );
}
